import type { FormGenerator } from "./GenerateForm";

export class NullFormGenerator implements FormGenerator {
    public readonly getAllDependenciesHash: FormGenerator["getAllDependenciesHash"] = () => {
        throw new Error("GenerationNotSupported");
    };

    public readonly getDictionary: FormGenerator["getDictionary"] = () => {
        throw new Error("GenerationNotSupported");
    };

    public readonly getLocalizedSugar: FormGenerator["getLocalizedSugar"] = () => {
        throw new Error("GenerationNotSupported");
    };

    public readonly readSources: FormGenerator["readSources"] = () => {
        throw new Error("GenerationNotSupported");
    };

    public readonly readSourcesAndProcessSugar: FormGenerator["readSourcesAndProcessSugar"] = () => {
        throw new Error("GenerationNotSupported");
    };
}
